import React from "react";
import { Modal, List } from "antd";

const ModalSeleccionVLX = ({ open, items, onClose, onSelect }) => {
  return (
    <Modal
      open={open}
      title="Seleccione lote / vencimiento"
      footer={null}
      onCancel={onClose}
    >
      <List
        dataSource={items}
        renderItem={(item) => (
          <List.Item
            onClick={() => onSelect(item)}
            style={{
              cursor: "pointer",
              padding: "12px 8px",
            }}
          >
            <List.Item.Meta
              title={
                item.valcar ||
                (item.lote && item.vto
                  ? `Lote: ${item.lote} - VTO: ${item.vto}`
                  : "Sin lote/vto")
              }
              description={`${item.sku} - ${item.nombre}`}
            />
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default ModalSeleccionVLX;
